import { apiService } from 'app/utils/api.service';
import { ISignInArgs } from './types';

const authServices = {
  signIn: (params: ISignInArgs) =>
    apiService.post(window.appConfig.api.auth.signIn, params)
};

export default authServices;
